import type React from "react";

import {useLevelV2} from "~/api/hooks/useLevelV2";
import {useGroupSession} from "~/contexts/session/GroupSessionProvider";

import GameContainer from "../../../component/game/GameContainer";
import CameraControlsDuringPlay from "../../../three/camera/CameraControlsDuringPlay";
import DeathExplosion from "../../../three/effects/DeathExplosion";
import GoalExplosion from "../../../three/effects/GoalExplosion";
import ImpulseEffect from "../../../three/effects/ImpulseEffect";
import ParticleTrails from "../../../three/effects/ParticleTrails";
import ShardCollectedAnimation from "../../../three/effects/ShardCollectedAnimation";
import Players from "../../../three/player/Players";

const CoopR3F: React.FC = () => {
  const {sessionData} = useGroupSession();
  const {data: level} = useLevelV2({
    id: sessionData?.current_round?.levelId,
  });
  return (
    <>
      {level && <GameContainer id={level.id} levelData={level.data} />}
      <CameraControlsDuringPlay following={true} />
      <Players />
      <ImpulseEffect />
      <ParticleTrails />
      <GoalExplosion />
      <DeathExplosion />
      <ShardCollectedAnimation />
    </>
  );
};

export default CoopR3F;
